import { Icon } from '@openeducation/oe-rn-components';
import Color from 'color';
import React from 'react';
import {
  Insets,
  Platform,
  StyleSheet,
  TouchableOpacity,
  TouchableOpacityProps,
  View,
} from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

import { useColors } from '../../../hooks';

interface PlayerButtonProps extends TouchableOpacityProps {
  isPlaying: boolean;
  activeColor?: string;
  inactiveColor?: string;
  isLoading?: boolean;
  hitSlop?: Insets | undefined;
}

export function PlayerButton({
  isPlaying = false,
  activeColor = undefined,
  inactiveColor = undefined,
  isLoading = false,
  ...props
}: PlayerButtonProps) {
  const theme = useColors();
  let buttonColor = inactiveColor || theme.onBackground;

  if (isLoading) {
    return (
      <View style={styles.container}>
        <View {...props}>
          <ActivityIndicator color={inactiveColor} size="small" />
        </View>
      </View>
    );
  }

  if (props.disabled) {
    buttonColor = Color(theme.gray).alpha(0.3).string();
  } else if (isPlaying) {
    buttonColor = activeColor || theme.primary;
  }

  return (
    <View style={styles.container}>
      <TouchableOpacity {...props}>
        <Icon
          color={buttonColor}
          size={22}
          name={isPlaying ? 'pause' : 'play'}
          type="solid"
        />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: Platform.select({
      web: 0,
      ios: 9,
      android: -3,
    }),
  },
});
